module.exports = __webpack_public_path__ + "img/poster_bg_2.98f13c74.png";